import { create } from "zustand";
import { startRouteTracking, endRouteTracking, initUnloadTracking } from "@services/route-tracking";

const getInitialView = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const viewOptions = ['karta', 'overblick', 'annonser', 'pricing'];

    if (urlSearchParams.get('view') && viewOptions.includes(urlSearchParams.get('view'))) {
        return { comp: urlSearchParams.get('view') };
    }

    if (history.state && history.state != null) {
        return history.state;
    }

    return { comp: 'overblick' };
}

const initialView = getInitialView();
startRouteTracking(initialView.comp);
initUnloadTracking();

export const useNavigationStore = create((set) => ({
  view: initialView,
  openSectionID: null,
  setView: (newView) => {
    endRouteTracking();              
    startRouteTracking(newView.comp);
    set({ view: newView });
  },
  openSectionDetails: (newSectionID) => {
    set({openSectionID: newSectionID})
  }
}));
